import { SigmaPropConstPrefixHex } from "../constants";
import { RustModule } from "../utils/rustLoader";
export class Int32Constant {
    constructor(value) {
        this.value = value;
    }
}
export class Int64Constant {
    constructor(value) {
        this.value = value;
    }
}
export class ByteaConstant {
    constructor(value) {
        this.value = value;
    }
}
export class Int32ArrayConstant {
    constructor(value) {
        this.value = value;
    }
}
export class SigmaPropConstant {
    constructor(value) {
        this.value = value;
    }
}
export function serializeConstant(c) {
    let constant;
    if (c instanceof Int32Constant)
        constant = RustModule.SigmaRust.Constant.from_i32(c.value);
    else if (c instanceof Int64Constant)
        constant = RustModule.SigmaRust.Constant.from_i64(RustModule.SigmaRust.I64.from_str(c.value.toString()));
    else if (c instanceof Int32ArrayConstant)
        constant = RustModule.SigmaRust.Constant.from_i32_array(c.value);
    else if (c instanceof SigmaPropConstant)
        constant = RustModule.SigmaRust.Constant.decode_from_base16(SigmaPropConstPrefixHex + c.value);
    else
        constant = RustModule.SigmaRust.Constant.from_byte_array(c.value);
    return constant.encode_to_base16();
}
export function deserializeConstant(r) {
    const constant = RustModule.SigmaRust.Constant.decode_from_base16(r);
    try {
        return new Int32Constant(constant.to_i32());
    }
    catch (e) {
        try {
            return new Int64Constant(BigInt(constant.to_i64().to_str()));
        }
        catch (e) {
            const hex = constant.encode_to_base16();
            const prefix = hex.slice(0, SigmaPropConstPrefixHex.length);
            if (prefix === SigmaPropConstPrefixHex) {
                return new SigmaPropConstant(hex.slice(SigmaPropConstPrefixHex.length));
            }
            else {
                try {
                    return new Int32ArrayConstant(constant.to_i32_array());
                }
                catch (e) {
                    try {
                        return new ByteaConstant(constant.to_byte_array());
                    }
                    catch (e) {
                        return undefined;
                    }
                }
            }
        }
    }
}
//# sourceMappingURL=data:application/json;base64,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